import { useState } from 'react';
import Header from '../../../../components/Header';
import CustomDrawer from '../../../components/customDrawer';
import UseCreditNoteDetails from '../hooks/useCreditNoteDetails';
import CustomAlertModel from '../../../components/customAlertModel';
import SalesCreditNotePdfView from './salesCreditNotePdfView';
import PageLoader from '../../../../../component/PageLoader';
import ApplyInvoice from '../../../../components/applyInvoice';
import CustomSalesDrawer from '../../../components/customSalesDrawer';
import CreditNoteTabs from './creditNoteTabs';
import { getDate } from '../../../../../utils/dateUtils';
import Button from '../../../../../component/ui/Button';
import Modal from '../../../../../component/modal/Modal';
import { hasPermission } from '../../../../../utils/controller';

const SalesCreditNoteDetails = () => {
	const {
		user,
		generateSalesCreditNotePdf,
		id,
		isDeleteCNModalOpen,
		setIsDeleteCNModalOpen,
		loading,
		navigate,
		suburl,
		creditNoteDetails,
		handleDeleteCreditNote,
		setIsApplyInvoiceModalOpen,
		isApplyInvoiceModalOpen,
		getCreditNoteDetails,
	} = UseCreditNoteDetails();
	const [drawerType, setDrawerType] = useState('');
	const [prId, setPrId] = useState('');
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [isOpenModelForInvoice, setIsOpenModelForInvoice] = useState(false);
	const [isSalesDrawerOpen, setIsSalesDrawerOpen] = useState(false);

	return (
		<div style={{ backgroundColor: '#EDEDF7', height: '100%', overflowY: 'auto' }}>
			<div
				style={{
					position: 'sticky',
					top: 0,
					zIndex: 30,
					backgroundColor: '#EDEDF7',
					boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
				}}
			>
				<Header
					headerTitle="Credit Note Details"
					closeButton={{
						showCloseButton: true,
						handler: () => navigate(`/user/${suburl}/sales/credit-note`),
					}}
					buttons={[
						creditNoteDetails &&
							creditNoteDetails?.status !== 'Closed' &&
							Number(creditNoteDetails?.total_paid_amount) === 0 && {
								className: 'btn-gray mt-0 px-4 ',
								button: 'Edit',
								disabled: !hasPermission('sales.credit_notes.edit', user?.role?.role_permissions),
								isDropdown: false,
								handler: () => navigate(`/user/${suburl}/sales/credit-note-create/${id}`),
							},
						creditNoteDetails && {
							title: 'Share',
							isDropdown: true,
							options: [
								{
									id: '1.1',
									disabled: !hasPermission(
										'sales.credit_notes.communications_email',
										user?.role?.role_permissions,
									),
									handler: () => navigate(`/user/${suburl}/sales/credit-note-send-emails/${id}`),
									title: 'Send Email',
								},
								{
									id: '1.3',
									disabled: !hasPermission(
										'sales.credit_notes.download_print_pdf',
										user?.role?.role_permissions,
									),
									handler: () => generateSalesCreditNotePdf('print', false),
									title: 'Pdf/Print',
								},
							],
						},
						creditNoteDetails &&
							creditNoteDetails?.status !== 'Closed' && {
								className: 'btn-gray mt-0 px-4 ',
								disabled: !hasPermission('sales.invoices.create', user?.role?.role_permissions),
								button: 'Apply Invoice',
								handler: () => {
									if (creditNoteDetails?.invoices.length > 0) {
										setIsApplyInvoiceModalOpen(true);
									} else {
										setIsOpenModelForInvoice(true);
									}
								},
							},
						creditNoteDetails &&
							creditNoteDetails?.status !== 'Closed' &&
							Number(creditNoteDetails?.total_paid_amount) === 0 && {
								className: 'btn-gray mt-0 px-4 ',
								button: 'Delete',
								disabled: !hasPermission('sales.credit_notes.delete', user?.role?.role_permissions),
								handler: () => setIsDeleteCNModalOpen(true),
							},
					].filter(Boolean)}
				/>
				<CreditNoteTabs
					InvoicesSettled={
						creditNoteDetails && creditNoteDetails?.applied_credit_notes_transactions?.length > 0
							? creditNoteDetails?.applied_credit_notes_transactions?.map((ele) => {
									return {
										id: ele.invoice_id || 'N/A',
										DATE: getDate(ele?.invoice_date || 'N/A'),
										'INVOICE NO #': ele?.inovice?.invoice_number || 'N/A',
										'INVOICE AMOUNT': Number(ele?.invoice_amount || 0).toFixed(2),
										'APPLIED AMOUNT': Number(ele?.total_applied_amount || 0).toFixed(2),
										'BALANCE DUE': Number(
											Number(ele?.invoice_balance_due || 0) -
												Number(ele?.total_applied_amount || 0),
										).toFixed(2),
									};
								})
							: []
					}
				/>
			</div>
			{loading ? (
				<PageLoader />
			) : (
				<SalesCreditNotePdfView
					creditNoteDetails={creditNoteDetails}
					setIsDrawerOpen={setIsDrawerOpen}
					setIsSalesDrawerOpen={setIsSalesDrawerOpen}
					setDrawerType={setDrawerType}
					setPrId={setPrId}
				/>
			)}
			{isDeleteCNModalOpen && (
				<CustomAlertModel
					setIsAlertModelOpen={setIsDeleteCNModalOpen}
					isAlertModelOpen={isDeleteCNModalOpen}
					customText={'Are you sure you want to delete credit'}
					objectSelectedList={[]}
					title={'Delete Credit note'}
					objectLength={''}
					handleBulk={() => handleDeleteCreditNote()}
				/>
			)}
			{isApplyInvoiceModalOpen && (
				<ApplyInvoice
					getCreditNoteDetails={getCreditNoteDetails}
					creditNoteDetails={creditNoteDetails}
					isApplyInvoice={isApplyInvoiceModalOpen}
					setIsApplyInvoice={setIsApplyInvoiceModalOpen}
				/>
			)}

			{isOpenModelForInvoice && (
				<Modal
					className="deleteVendorsModal"
					title="Invoice Unavailable"
					isOpen={isOpenModelForInvoice}
					onClose={() => {
						setIsOpenModelForInvoice(false);
					}}
					cancelButton={() => {
						setIsOpenModelForInvoice(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						There is no open invoice related to this customer
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Cancel"
							className="mt-0 px-4 btn-gray relative"
							onClick={() => setIsOpenModelForInvoice(false)}
						/>

						<Button
							type="button"
							button="Create New Invoice"
							disabled={!hasPermission('sales.invoices.create', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								navigate(`/user/${suburl}/invoices-create`, {
									state: {
										key: Number(creditNoteDetails?.customer?.id),
										value: creditNoteDetails?.customer?.name,
									},
								});
							}}
						/>
					</div>
				</Modal>
			)}
			{
				<CustomSalesDrawer
					isOpen={isSalesDrawerOpen}
					onClose={() => setIsSalesDrawerOpen(false)}
					id={prId}
					type={'Payment Received'}
				/>
			}

			{
				<CustomDrawer
					isOpen={isDrawerOpen}
					onClose={() => setIsDrawerOpen(false)}
					id={drawerType === 'customer' ? creditNoteDetails.customer_id : null}
					drawerType={drawerType}
					activeDrawer={'Details'}
				/>
			}
		</div>
	);
};
export default SalesCreditNoteDetails;
